import { render, staticRenderFns } from "./Subscriptions.vue?vue&type=template&id=1243fba8&scoped=true"
import script from "./Subscriptions.vue?vue&type=script&lang=ts"
export * from "./Subscriptions.vue?vue&type=script&lang=ts"
import style0 from "./Subscriptions.vue?vue&type=style&index=0&id=1243fba8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1243fba8",
  null
  
)

export default component.exports